import { render, staticRenderFns } from "./RcpyPD_Details.vue?vue&type=template&id=18866aac"
import script from "./RcpyPD_Details.vue?vue&type=script&lang=js"
export * from "./RcpyPD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports